import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import TagManager from 'react-gtm-module'

import 'moment/dist/locale/pt-br'
import 'numeral/locales/pt-br'

import { Routes } from '@routes/routes'
import ToastProvider from '@stores/toast.context/toast.context'
import newRelic from '@services/newrelic'
import injectNavattic from '@services/navattic'

import moment from 'moment'
import numeral from 'numeral'

const SW_VERSION = import.meta.env.VITE_SW_VERSION
const CURRENT_VERSION = import.meta.env.VITE_CURRENT_SW_VERSION

numeral.locale('pt-br')
moment.updateLocale('pt-br', {
  calendar: {
    sameDay: '[hoje às] HH:mm',
    nextDay: '[amanhã às] HH:mm',
    nextWeek: '[próxima] dddd',
    lastDay: '[ontem às] HH:mm',
    lastWeek: '[última] dddd',
    sameElse: 'DD/MM/YYYY [às] HH:mm',
  },
})

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
})

const App = () => {
  useEffect(() => {
    if (import.meta.env.NODE_ENV === 'production') {
      // New Relic
      newRelic.injectNewRelic()
    }

    // Google Tag Manager
    if (import.meta.env.VITE_ANALYTICS_GTM_ID) {
      const gtmId = import.meta.env.VITE_ANALYTICS_GTM_ID
      TagManager.initialize({ gtmId })
    }

    // Navattic
    injectNavattic()
  }, [])

  useEffect(() => {
    const registerServiceWorker = async () => {
      console.log('Iniciando registro do Service Worker...')
      try {
        if ('serviceWorker' in navigator) {
          // Verifica se há uma nova versão do SW
          if (import.meta.env.NODE_ENV === 'production' && SW_VERSION !== CURRENT_VERSION) {
            console.log('Nova versão do Service Worker detectada, atualizando...')
            const registrations = await navigator.serviceWorker.getRegistrations()
            for (const registration of registrations) {
              await registration.unregister()
            }
            window.location.reload()
            return
          }

          const registration = await navigator.serviceWorker.register('/sw.js', {
            scope: '/',
          })

          if (registration.active) {
            console.log('Service Worker já está ativo')
          } else {
            console.log('Service Worker está instalando...')
          }
        } else {
          console.error('Service Worker não é suportado neste navegador')
        }
      } catch (error) {
        console.error('Erro ao registrar Service Worker:', error)
      }
    }

    registerServiceWorker()
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <Routes />
      </ToastProvider>
    </QueryClientProvider>
  )
}

export default App
